import { render, staticRenderFns } from "./LeaveApprover.vue?vue&type=template&id=5f0dcba9"
import script from "./LeaveApprover.vue?vue&type=script&lang=js"
export * from "./LeaveApprover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports